'use strict';

global.utl = require('../utils.js');
global.offset = 0;

var limit = 9;
var loaded = false;
var finish = false;
var init = true;

var self = module.exports = {
  init: function () {
    if (init == true) {
      self.loadMore(global.offset, limit);
      self.existMore(global.offset + limit, 1);
    }

    $(window).scroll(function() {
      var end = $("#load-more").offset().top;
      var viewEnd = $(window).scrollTop() + $(window).height();
      var distance = end - viewEnd;

      if (distance < 100 && loaded == false && finish == false && init == false) {
        self.loaded();
        self.loadMore(global.offset, limit);
        self.existMore(global.offset + limit, 1);
      }
    });

  },

  loaded: function() {
    loaded = true;
  },

  loadMore: function(offset, limit) {
    $.ajax({
      method: 'GET',
      url: '/rest/widgets/widgetpreview/dicono_di_noi/' + offset + ',' + limit + '/dateOrd,desc',
    }).done(function(data) {
      (function(data, offset) {

        var template = $('#ddn-template').html();
        var wrapper = $('[data-js="landing-wrapper"]');
        global.offset += data.length;

        mustache.parse(template);
        var rendered = mustache.render(template, {'widgets': data});
        wrapper.append(rendered);

        $(document).foundation();

        var moodboard = wrapper.find('.landing-moodboard');

        $.each(moodboard, function(key, group) {
          var modules = $(group).find('.ddn-module');

          if (key == moodboard.length -1) {
            $.each(modules, function(key, element) {
              var text = $(element).find('.ddn-module__date').text().trim().replace(/ /g,'T');
              var dateWidget = new Date(text);
              var dateFormatWidget = dateWidget.getDate() + ' ' + utl.getMonthName(dateWidget) + ' ' + dateWidget.getFullYear();
              $(element).find('.ddn-module__date').text(dateFormatWidget);
            });
          }
        });

        loaded = false;
        init = false;

      })(data, offset);
    });
  },

  existMore: function(offset, limit) {
    $.ajax({
      method: 'GET',
      url: '/rest/widgets/widgetpreview/dicono_di_noi/' + offset + ',' + limit + '/dateOrd,desc',
    }).done(function(data) {
      (function(data, offset) {
        if (data.length > 0) {
          $('#load-more').removeClass('hide');
        } else {
          finish = true;
          $( document ).ajaxStop(function() {
              $('#load-more').addClass('hide');
          });
        }
      })(data, offset);
    });
  }
};

self.init();
